<template>
	<div class="cg">
		<div class="bg" @click="close"></div>
		<div class="content">
			<img src="@/assets/images/cg.png" class="cg_icon" />
			<p>{{ innerText }}</p>
			<button  class="btn" @click="open_live">{{isChecked  ? '返回' : btnTxt}}</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Cg',
	props: {
		isChecked:{  //是否需要审核
			typeof: Boolean,
			default: false
		},
	
		text: {
			typeof: String,
			default: '注册成功'
		},
		liveUrl: {
			typeof: String,
			default: ''
		},
		
		isTop: {
			typeof: [String,Number],
			default: 0
		}
	},
	data() {
		return {
			innerText:"报名成功",
			btnTxt:""
		};
	},

	mounted() {
		console.log("this.isChecked",this.isChecked);
		// 监听全屏状态的变化
		this.setText();
		this.setBtnTxt();

	},
	methods: {
		setBtnTxt(){
			if(this.isTop == 1 || this.isTop == 2){
				this.btnTxt = "进入活动"
			}else{
				this.btnTxt = "进入直播间"
			}
		},
		setText(){
			if(this.isChecked){
				this.innerText = "感谢您的注册！您的申请已提交，我们将尽快对您的信息进行审核。审核完成后，您将通过模板消息收到审核结果通知，请保持关注。"
			}
		},
		open_live() {
			if(this.isChecked){
				this.$emit('close', false);
			}else{
				this.$emit('notCheck', false);
				
				
			}
			
		},
		close() {
			this.$emit('close', false);
		}
	}
};
</script>

<style scoped lang="less">
.cg {
	width: 828px;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999;

	.bg {
		background-color: rgba(0, 0, 0, 0.8);
		width: 100%;
		height: 100%;
	}

	.content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateY(-50%) translateX(-50%);
		z-index: 11;
		width: 640px;
		height: auto;
		background: #ffffff;

		.cg_icon {
			width: 93px;
			height: 93px;
			display: block;
			margin: 60px auto 30px;
		}

		p {
			text-align: center;
			font-size: 40px;
			color: #991d85;
			line-height: 1.2;
			padding: 40px;
			margin-bottom: 60px;
		}

		.btn {
			width: 360px;
			height: 90px;
			background: #991d85;
			border: 2px solid #991d85;
			box-shadow: 0px 16px 27px 0px rgba(0, 0, 0, 0.23);
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 34px;
			color: #ffffff;
			line-height: 1;
			margin: 0 auto 60px;
		}
	}
}
</style>
